import { Text, StyleSheet, Platform, Alert, Modal, View, TouchableOpacity, Switch } from 'react-native';
import {
  ColorTokens,
  ColorTokensMap,
  FontFamilyTokens,
  FontSizeTokens,
  SizeTypeTokens,
  TextAlignTokens,
  TypographyTypeDLS,
  ButtonTypeTokens,
  ButtonWidthTypeToken,
} from '@voltmoney/schema';
import React, { useEffect, useState } from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import { themeColorSet, ThemedPressable, ThemedView } from '../../theme';
import Svg from '@sharedComponents/SvgImage/Svg';
import { BASE_IMAGE_URL } from '../../configs/constants';
import Typography from '@sharedComponents/typography/Typography';
import ThemeProvider from '@voltmoney/theme';
import LogoutIcon from '../../../assets/Icons/LogoutIcon';
import Question from '../../../assets/Icons/QuestionIcon';
import ContactIcon from '../../../assets/Icons/ContactIcon';
import InfoIcon from '../../../assets/Icons/InfoIcon';
import { CaretRight, X } from '@app/sharedComponents/Icons/index';
import LogOutUser from '@app/helper/logout';
import {useAppSelector} from '@app/store/hooks'
import { ThemedText, ThemedTouchableOpacity } from '@app/theme/Components';
import {getVersion} from 'react-native-device-info'
import TypographyBase from '@app/sharedComponents/typography/Typography.base';
import ScreenWrapper from '@app/hoc/ScreenWrapper';
import {Button, Space} from '@voltmoney/component';
import {BIOMETRIC_USER_CANCELLED, biometricLocalPermission, checkColor, CREDIT_STATUS, showHelpAndSupportField, trackEvent, useDarkMode} from '@app/utils';
import BiometricPermission from '../../../assets/Icons/BiometricPermission';
import SystemErrorIcon from "../../../assets/Icons/SystemErrorIcon";
import RNBiometrics from "react-native-simple-biometrics";
import useSingleRemoteConfig from "@hooks/useSingleRemoteConfig";
import {BUILD_TYPE, getBuildType} from "@voltmoney/micro-frontend";

import AccountProfile from '../../../assets/Icons/Account_profile';
import ROUTE from '@app/navigationApp/routes';
import LoanProfile from '../../../assets/Icons/LoanProfile';
import LoanClosure from '../../../assets/Icons/Foreclosure';
import { LENDER_ID } from '@app/constants/platformPartners';
import axios from 'axios';
import { endpoints } from '@app/api/apis';
import dayjs from 'dayjs';
import HeadPhone from '../../../assets/Icons/Headphone';
import AsyncStorage from '@react-native-async-storage/async-storage';

type ScreenProps = NativeStackScreenProps<
  PrivateStackParamList,
  'USER_PROFILE'
>;

type MENU_ITEMS_TYPE = {
    id: number | string;
    label: string;
    navigateTo: keyof PrivateStackParamList;
    icon: React.ReactNode;
}[];

const MENU_ITEMS: MENU_ITEMS_TYPE = [
    {
        id: 1,
        label: 'FAQs',
        navigateTo: 'FAQ',
        icon: <Question size={24} color={checkColor("#1434CB")}/>,
    },
    {
        id: 2,
        label: 'Contact us',
        navigateTo: 'CONTACT_US',
        icon: <ContactIcon size={24} color={checkColor("#1434CB")}/>,
    },
    {
        id: 3,
        label: 'About us',
        navigateTo: 'ABOUT_US',
        icon: <InfoIcon size={24} fill={checkColor("#1434CB")}/>,
    },
  ]

const LOS_MENU_ITEMS: MENU_ITEMS_TYPE = [
  {
    id: 1,
    label: 'FAQs',
    navigateTo: 'FAQ',
    icon: <Question size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 2,
    label: 'Contact us',
    navigateTo: 'CONTACT_US',
    icon: <ContactIcon size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 3,
    label: 'About us',
    navigateTo: 'ABOUT_US',
    icon: <InfoIcon size={24} fill={checkColor("#1434CB")}/>,
  },
];

const LMS_MENU_ITEMS: MENU_ITEMS_TYPE = [
  {
    id: "txt_profileScreen_accountDetails",
    label: 'Account details',
    navigateTo: ROUTE.ACCOUNT_DETAILS,
    icon: <AccountProfile size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 'txt_profileScreen_loanDetails',
    label: 'My loan details',
    navigateTo: ROUTE.LOAN_DETAILS,
    icon: <LoanProfile size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 'txt_profileScreen_FAQ',
    label: 'FAQs',
    navigateTo: 'FAQ',
    icon: <Question size={24} color={checkColor("#1434CB")}/>,

  },
  {
    id: 'txt_profileScreen_helpAndSupport',
    label: 'Help and support',
    navigateTo: 'HELP_AND_SUPPORT_SCREEN_REVAMP',
    icon: <HeadPhone size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 'txt_profileScreen_contactUs',
    label: 'Contact us',
    navigateTo: 'CONTACT_US',
    icon: <ContactIcon size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 'txt_profileScreen_trackClosureRequest',
    label: 'Track closure request',
    navigateTo: 'CONTACT_US',
    icon: <ContactIcon size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 'txt_profileScreen_aboutUs',
    label: 'About us',
    navigateTo: 'ABOUT_US',
    icon: <InfoIcon size={24} fill={checkColor("#1434CB")}/>,
  },
   {
    id: 'txt_profileScreen_loanForeclosure',
    label: 'Close account',
    navigateTo: 'HOW_TO_CLOSE_ACCOUNT',
    icon: <LoanClosure size={24} color={checkColor("#1434CB")}/>,
  },
];

const filteredList = (isLoanRenewalInProgress : boolean,showLoanDetails : boolean,showContactUs : boolean,isPendingForeclosure : boolean,isLoanExpired : boolean,hideAboutUs : boolean,hideFaq : boolean,showHelpAndSupport : boolean,preLoanFlowUI : boolean,showForeclosureTracking : boolean, isBajajUser:boolean) => { 
  const idsToRemove: string[] = [];
  const profileList = LMS_MENU_ITEMS;
  if (isLoanRenewalInProgress) {
      idsToRemove.push('txt_profileScreen_loanForeclosure');
  }
  if(!showLoanDetails){
      idsToRemove.push('txt_profileScreen_loanDetails');
  }
  if (!showContactUs) {
      idsToRemove.push('txt_profileScreen_contactUs');
  }
  if (isPendingForeclosure || isLoanExpired) {
      idsToRemove.push('txt_profileScreen_loanForeclosure', 'txt_profileScreen_trackClosureRequest');
  }

  if(hideAboutUs){
      idsToRemove.push('txt_profileScreen_aboutUs');
  }

  if(hideFaq){
      idsToRemove.push('txt_profileScreen_FAQ' , 'txt_profileScreen_helpAndSupport');
  }

  if (preLoanFlowUI) {
      if (showForeclosureTracking) {
        idsToRemove.push('txt_profileScreen_loanForeclosure');
      } else {
          idsToRemove.push(
              'txt_profileScreen_accountDetails',
              'txt_profileScreen_trackClosureRequest',
              'txt_profileScreen_loanForeclosure',
          );
      }
  } else if (!isPendingForeclosure) {
      idsToRemove.push('txt_profileScreen_trackClosureRequest');
  }

  if(showHelpAndSupport){
      idsToRemove.push('txt_profileScreen_loanForeclosure');
      idsToRemove.push('txt_profileScreen_contactUs');
      idsToRemove.push('txt_profileScreen_FAQ');
  } else {
      idsToRemove.push('txt_profileScreen_helpAndSupport');
  }
  if(isBajajUser){
      idsToRemove.push('txt_profileScreen_loanForeclosure');
  }
  return profileList.filter(item => !idsToRemove.includes(item.id as string));
};


const renderBlurView = () => {
    return (
        <View
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                zIndex: 99,
                ...StyleSheet.absoluteFillObject
            }}
        />
    )
}

const _renderLogoutConfirmationModal = (
    modalVisible: boolean,
    setModalVisible: Function,
  ) => (
    <Modal
      animationType={'fade'}
      transparent={true}
      visible={modalVisible}
      onRequestClose={() => {}}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          backgroundColor: '#1D293966',
        }}>
        <View
          style={{
            backgroundColor: 'white',
            width: '70%',
            maxWidth: 508,
            height: '20%',
            borderRadius: 10,
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: 'black',
            borderWidth: 2,
            padding: 10,
          }}>
          <Typography
            label="Are you sure you want to logout?"
            color={ColorTokens.Grey_Charcoal}
            fontSize={FontSizeTokens.SM}
            fontFamily={FontFamilyTokens.Poppins}
            fontWeight="400"
            lineHeight={24}
            textAlign={TextAlignTokens.center}
          />
          <Space.Component size={SizeTypeTokens.MD} />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              width: '100%',
              height: 35,
              alignItems: 'center',
            }}>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                width: '100%',
              }}>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={LogOutUser}>
                  <Typography
                    label="Yes"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={() => setModalVisible(false)}>
                  <Typography
                    label="No"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );

const handleMobileLogout = () =>
  Alert.alert('', 'Are you sure you want to Logout?', [
    {
      text: 'Cancel',
      style: 'cancel',
    },
    {text: 'OK', onPress: LogOutUser},
  ]);

const UserProfile = ({ navigation , route }: ScreenProps) => {
  const {showLogout} = useAppSelector(state => state.platformParams);
  const theme = ThemeProvider.getTheme();
  const colorMapping: ColorTokensMap = theme.colors;
  const userDetails = useAppSelector(state => state.auth.userDetails);
  const [modalVisible , setModalVisible] = useState(false)
  const isDarkMode = useDarkMode();
  const [showBiometricCancelledCard, setShowBiometricCancelledCard] = useState(false);
  const [userBiometricSuccess, setUserBiometricSuccess] = useState(true)
  const [isBiometricsEnabled, setBiometricsEnabled] = useState(false)
  const [showBiometricOption, setShowBiometricOption] = useState(false)
  const biometricsStaging= useSingleRemoteConfig('enable_biometrics_staging').configValue
  const biometricsProduction= useSingleRemoteConfig('enable_biometric').configValue
  const [isAccountInForeClosure, setIsAccountInForeClosure] = useState({});
  const {pendingRequestDetails} = useAppSelector(state => state.auth.pendingRequestDetails)
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);

  const isLoanRenewalInProgress = pendingRequestDetails?.data?.renewalRequestDetailsList?.length;
  let showLoanDetails = false;
  const creditStatus = userDetails?.linkedCredits[0]?.creditStatus;
  if((creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED || creditStatus === CREDIT_STATUS.ACTIVE)){
    showLoanDetails = true;
  } else  showLoanDetails = false;

  const showContactUs = true; // Need to handle for investwell
  let isPendingForeclosure = userDetails?.linkedCredits[0]?.creditStatus === "PENDING_CLOSURE";

  const renewalDate = dayjs(userDetails?.linkedCredits[0]?.renewalDate)
  const currentDate = dayjs()
  const isLoanExpired = renewalDate.isBefore(currentDate) ;
  const hideAboutUs = userDetails?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileAboutUs === false
  const hideFaq = userDetails?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileFaq === false
  let preLoanFlowUI = userDetails?.linkedApplications[0].applicationState !== "COMPLETED"

  const showHelpAndSupport = showHelpAndSupportField(userDetails);
  let showForeclosureTracking = false
  let foreclosureTrackingResponse
  let showNewFlow = false;

  if (userDetails.linkedApplications[0].applicationState === "COMPLETED") {
    const manageLimitConfig =  endpoints.manageLimitConfig + userDetails?.linkedCredits[0]?.creditId

    axios.get(manageLimitConfig)
      .then((res) => {
        showNewFlow = res?.data?.loanForeClosureAllowed;
        if (!isPendingForeclosure) {
          if (showNewFlow) {
              isPendingForeclosure = false
          } else {
              isPendingForeclosure = true
          }
      }
      })
      .catch((err) => {
        console.log('err', err);
      });
    preLoanFlowUI = false;
  } else preLoanFlowUI = true;

  if (userDetails.linkedApplications[0].applicationState === 'IN_PROGRESS') {
    const url = endpoints.getForeclosureCompleted + userDetails?.linkedBorrowerAccounts[0].accountId;
    axios.get(url)
      .then((res) => {
        showForeclosureTracking = true;
        foreclosureTrackingResponse = res?.data;
      })
      .catch((err) => {
        console.log('err', err);
        if (err?.response?.data?.statusCode === "400") {
          showForeclosureTracking = false;
        }
      });
  }



  const renderMenuItems = filteredList(isLoanRenewalInProgress,showLoanDetails,showContactUs,isPendingForeclosure,isLoanExpired,hideAboutUs,hideFaq,showHelpAndSupport,preLoanFlowUI,showForeclosureTracking,userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ);
  

  const navigateToOldForeclosure = () => {
    AsyncStorage.setItem('isBajajClosure', 'true');
    navigation.navigate("MF_FETCH")
  }
   
  const doNavigation = (item) =>{
    if(item?.id==='txt_profileScreen_loanForeclosure' && userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ){
      {
        navigation.navigate(ROUTE.OLD_FORECLOSURE)
      }
    }else{
      if(item?.id==='txt_profileScreen_helpAndSupport'){
        navigation.navigate(item?.navigateTo,{userName : userDetails?.user?.fullName})
      }else{
        navigation.navigate(item?.navigateTo)
      }
    }
  }

  const fetchForClosureStatus = () =>{
      if(userDetails?.linkedCredits[0]?.creditStatus !== 'PENDING_CLOSURE'){
        return
      }
      const url = endpoints.checkForClosureStatus + userDetails?.linkedCredits[0]?.creditId
      axios.get(url)
      .then((res)=>{
        setIsAccountInForeClosure(res?.data)
      }
      ).catch((err)=>{
        console.log('fetchClosureRequest',err)
      }
      )
    }
    useEffect(()=>{
      fetchForClosureStatus()
    },[])



    useEffect(() => {
        if (isBiometricsEnabled) {
            trackEvent("BIOMETRICS_SETTINGS_ENABLED")
        } else {
            trackEvent("BIOMETRICS_SETTINGS_DISABLED")
        }
    }, [isBiometricsEnabled]);



    const renderBiometricAuthenticationCancelled = () => {
        return (
            <Modal visible={true} transparent={true} animationType={'slide'}>
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        justifyContent: 'flex-end',
                    }}>
                    <View style={{
                        paddingHorizontal: 16,
                        paddingVertical: 24,
                        backgroundColor: 'white',
                        padding: 30,
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        width: '100%',
                    }}>
                        <View style={{marginTop: 12, marginBottom: 12}}>
                            <View style={{
                                alignItems: 'center',
                                alignSelf: 'center',
                                alignContent: 'center',
                                marginBottom: 12
                            }}>
                                <SystemErrorIcon size={60}/>
                            </View>
                            <Typography
                                label={
                                    "You have biometrics enabled"
                                }
                                fontSize={FontSizeTokens.XXL}
                                fontFamily={FontFamilyTokens.Inter}
                                textAlign={TextAlignTokens.center}
                                lineHeight={28}
                                fontWeight={"600"}
                                color={ColorTokens.Grey_Night}
                            />
                        </View>
                        <Typography
                            label={
                                "Kindly authorise with your biometric setup so we can safely let you in the app."
                            }
                            fontSize={FontSizeTokens.SM}
                            fontFamily={FontFamilyTokens.Inter}
                            textAlign={TextAlignTokens.center}
                            lineHeight={20}
                            fontWeight={"400"}
                            color={ColorTokens.Grey_Charcoal}
                        />
                        <View style={{marginTop: 36, marginBottom: 20, width: "100%"}}>
                            <Button.Component
                                type={ButtonTypeTokens.LargeFilled}
                                label={'Authenticate now'}
                                //@ts-ignore
                                fontSize={14}
                                width={ButtonWidthTypeToken.FULL}
                                onPress={async () => {
                                    await biometricAuthentication()
                                    trackEvent("CANCELLATION_CARD_AUTHETICATE_NOW", {
                                        deviceType: Platform.OS
                                    })
                                }}
                            />
                        </View>
                    </View>
                </View>
            </Modal>
        );
    };

    useEffect(() => {
        if (Platform.OS !== "web") {
            const biometricsPermission = getBuildType() !== BUILD_TYPE.BORROWER_PRODUCTION ? biometricsStaging : biometricsProduction
            const showBiometricPermissionOnTheList = async () => {
                try {
                    const canAuthenticate = await RNBiometrics.canAuthenticate();
                    if (canAuthenticate && biometricsPermission === "true") {
                        setShowBiometricOption(true);
                        const storedPermission = await AsyncStorage.getItem(biometricLocalPermission);
                        if (storedPermission === "true") {
                            setBiometricsEnabled(true);
                        } else {
                            setBiometricsEnabled(false);
                        }
                    } else {
                        setShowBiometricOption(false);
                    }
                } catch (error) {
                }
            };
            showBiometricPermissionOnTheList();
        }

    }, [biometricsStaging , biometricsProduction]);

    const biometricAuthentication = async () => {
        const accessToken = await AsyncStorage.getItem('access_token')
        setUserBiometricSuccess(false)
        if (accessToken !== null && accessToken !== undefined) {
            await RNBiometrics.canAuthenticate().then(async res => {
                if (res) {
                    setShowBiometricCancelledCard(false)
                    try {
                        await RNBiometrics.requestBioAuth("Authenticate to enter Volt App", "Please complete biometric authentication").then(async result => {
                            setUserBiometricSuccess(true)
                            await AsyncStorage.setItem(biometricLocalPermission, "true")
                            setBiometricsEnabled(!isBiometricsEnabled)
                }).catch(async error => {
                            // @ts-ignore
                            const errorString = error?.toString?.() ?? '';
                            if (BIOMETRIC_USER_CANCELLED.some(msg => errorString.includes(msg))) {
                                setShowBiometricCancelledCard(true);
                                setUserBiometricSuccess(false);
                                trackEvent("BIOMETRIC_AUTHENTICATION_CANCELLED", {
                                    deviceType: Platform.OS
                                })
                            } else {
                                trackEvent("BIOMETRIC_AUTHENTICATION_FAILED", {
                                    deviceType: Platform.OS
                                })
                            }
                        });
                    } catch(error) {
                        // @ts-ignore
                        const errorString = error?.toString?.() ?? '';
                        if (BIOMETRIC_USER_CANCELLED.some(msg => errorString.includes(msg))) {
                            setShowBiometricCancelledCard(true);
                            setUserBiometricSuccess(false);
                            trackEvent("BIOMETRIC_AUTHENTICATION_CANCELLED", {
                                deviceType: Platform.OS
                            })
                        } else {
                            trackEvent("BIOMETRIC_AUTHENTICATION_FAILED", {
                                deviceType: Platform.OS
                            })
                        }
                    }
                } else {
                    setUserBiometricSuccess(true);
                    setShowBiometricCancelledCard(false);
                }
            }).catch(error => {
                setUserBiometricSuccess(true);
                setShowBiometricCancelledCard(false);
            })
        }
    }

    const renderBiometricOption = () => {
        return (
            <ThemedPressable
                paddingHorizontal="lg"
                key={"5"}>
                <ThemedView
                    mr="xs"
                    style={[
                        {
                            borderBottomColor: '#f1f3f5',
                        },
                    ]}
                    borderBottomWidth={1}
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    paddingVertical="md">
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedView
                            mr='md'
                            height={40}
                            width={40}
                            alignItems="center"
                            justifyContent="center"
                            backgroundColor="bg-surface-page"
                            borderRadius="full">
                            <BiometricPermission />
                        </ThemedView>
                        <ThemedText color="text-primary" variant="b3m">
                            {"Enable biometric security"}
                        </ThemedText>
                    </ThemedView>
                    <Switch value={isBiometricsEnabled}  thumbColor={isBiometricsEnabled ? '#1434CB' : '#FFFFFF'} trackColor={{true: '#1434CB33', false : '#98A2B3'}} onValueChange={async(result) => {
                        if(result) {
                            await biometricAuthentication()
                        } else {
                            await AsyncStorage.setItem(biometricLocalPermission, "false")
                            setBiometricsEnabled(!isBiometricsEnabled)}}
                    }
                    />
                </ThemedView>
            </ThemedPressable>
        )
    }

  // @ts-ignore
    return (

  <>
    <ThemedView backgroundColor="bg-surface-primary" flex={1}>
      <ThemedView
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingVertical="md"
        paddingHorizontal="lg"
        borderBottomWidth={1}
        style={[
          {
            borderBottomColor: '#f1f3f5',
          },
        ]}>
        <ThemedView flexDirection="row" alignItems="center">
          <ThemedView mr='sm'>
            {
              userDetails?.user?.fullName ?
              <ThemedView
              height={40}
              width={40}
              backgroundColor='bg-action-primary'
              borderRadius='full'
              justifyContent='center'
              alignItems='center'>
              <ThemedText color='white' variant='h3s'>
              {userDetails?.user?.fullName[0]}
              </ThemedText>
              </ThemedView>
              :
              <Svg
              height={40}
              width={40}
              url={BASE_IMAGE_URL + 'profile_pre1.png'}
            />
            }
           
          </ThemedView>
          <ThemedText variant='h5s' color='text-primary'>
            {userDetails?.user?.fullName ??
              `+91 ${userDetails.user?.phoneNumber.split('+91')[1]}`}
          </ThemedText>
        </ThemedView>
        <ThemedTouchableOpacity
          hitSlop={{ left: 10, right: 10, bottom: 10, top: 10 }}
          mr="xs" onPress={() => navigation.goBack()}>
          <X size={18} />
        </ThemedTouchableOpacity>
      </ThemedView>
      <ThemedView mt="md">
        {renderMenuItems.map(item => {
          return (
            <ThemedPressable
              eventName='HELP_AND_SUPPORT_CATEGORY_SELECTED'
              additionalProperties={{source:'lms'}}
              onPress={() => doNavigation(item)}
              paddingHorizontal="lg"
              key={item.id}>
              <ThemedView
                mr="xs"
                style={[
                  {
                    borderBottomColor: '#f1f3f5',
                  },
                ]}
                borderBottomWidth={1}
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                paddingVertical="md">
                <ThemedView flexDirection="row" alignItems="center">
                  <ThemedView
                    mr='md'
                    height={40}
                    width={40}
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="bg-surface-page"
                    borderRadius="full">
                    {item?.icon}
                  </ThemedView>
                  <ThemedText color="text-primary" variant="b3m">
                    {item?.label}
                  </ThemedText>
                </ThemedView>
                <CaretRight color={themeColorSet['icon-primary']} />
              </ThemedView>
            </ThemedPressable>
          );
        })}
          {showBiometricOption ? renderBiometricOption() : <></>}
      </ThemedView>
     {!showHelpAndSupport && isLMSUser && userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ && 
     <ThemedPressable
              onPress={() =>{navigateToOldForeclosure()} }
              paddingHorizontal="lg"
             >
              <ThemedView
                mr="xs"
                style={[
                  {
                    borderBottomColor: '#f1f3f5',
                  },
                ]}
                borderBottomWidth={1}
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                paddingVertical="md">
                <ThemedView flexDirection="row" alignItems="center">
                  <ThemedView
                    mr='md'
                    height={40}
                    width={40}
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="bg-surface-page"
                    borderRadius="full">
                    <LoanClosure size={24} color={checkColor("#1434CB")}/>
                  </ThemedView>
                  <ThemedText color="text-primary" variant="b3m">
                    {"Loan closure"}
                  </ThemedText>
                </ThemedView>
                <CaretRight color={themeColorSet['icon-primary']} />
              </ThemedView>
            </ThemedPressable>}

      {
        showLogout && 
      <ThemedPressable
        onPress={() => {
          if(Platform.OS === 'web') {
            setModalVisible(true)
          }
          else {
            handleMobileLogout()
          }
        }}
        paddingHorizontal="lg"
        paddingVertical="sm"
        borderTopWidth={1}
        borderColor='border-secondary'
        position="absolute"
        width={'100%'}
        bottom={0}>
          <ThemedView
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center">
          <ThemedTouchableOpacity
          hitSlop={{left : 20 , right : 20 , top : 20 , bottom : 20}}
          eventName='LOGOUT_BUTTON'
          onPress={() => {
           if(Platform.OS === 'web') {
             setModalVisible(true)
           }
           else {
             handleMobileLogout()
           }
         }}
          flexDirection="row" alignItems="center">
            <ThemedView
              mr='md'
              height={40}
              width={40}
              alignItems="center"
              justifyContent="center"
              backgroundColor="bg-surface-page"
              borderRadius="full">
              <LogoutIcon color={checkColor("#1434CB")}/>
            </ThemedView>
            <Typography
              fontFamily={FontFamilyTokens.Inter}
              fontSize={FontSizeTokens.SM}
              fontWeight={'600'}
              lineHeight={20}
              label={'Logout'}
              color={
                isDarkMode ? ColorTokens.White_20 : ColorTokens.Primary_100
              }
            />
          </ThemedTouchableOpacity>
        {Platform.OS !== 'web' && (
          <ThemedView>
            <TypographyBase color={ColorTokens.Grey_Smoke} fontSize={FontSizeTokens.XS} typeDLS={TypographyTypeDLS.B3R} label={'App version ' + getVersion()} />
          </ThemedView>
        )}
        </ThemedView>
      </ThemedPressable>
      }
    </ThemedView>
    {_renderLogoutConfirmationModal(modalVisible, setModalVisible)}
    {showBiometricCancelledCard ? renderBiometricAuthenticationCancelled() : <></>}
    {!userBiometricSuccess ? renderBlurView(): <></>}
  </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5FCFF',
  },
  text: {
    fontSize: 20,
    textAlign: 'center',
    margin: 10,
  },
});

export default UserProfile;
